export type LoginContentModel = {
  greetingsText?: string;
  icons: {
    media: {
      name?: string;
      alternativeText?: string;
      url?: string;
    }[];
  }[];
  buttons: {
    label?: string;
    alt?: string;
    url?: string;
  }[];
};

export enum IdentifyCustomerByAddressResponse {
  NO_RESULT = 'NO_RESULT',
  ONE_RESULT = 'ONE_RESULT',
  MULTIPLE_RESULTS = 'MULTIPLE_RESULTS',
  VERIFIED_ACCOUNT = 'VERIFIED_ACCOUNT',
  UNVERIFIED_ACCOUNT = 'UNVERIFIED_ACCOUNT',
  ACCOUNT_CLOSED = 'ACCOUNT_CLOSED',
  UNIQUE_FOUND = 'UNIQUE_FOUND',
  POSTCODE_INVALID = 'POSTCODE_INVALID',
  TOO_SOON_TO_REGISTER = 'TOO_SOON_TO_REGISTER',
}
